"use client";

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCart } from "@/networking/carts.api";
import { useLocaleStore } from "@/lib/locale";

interface TranslationProviderProps {
  children: React.ReactNode;
  cartToken?: string; // Optional cart token for checkout pages
}

export default function TranslationProvider({
  children,
  cartToken,
}: TranslationProviderProps) {
  const setCurrentLanguage = useLocaleStore(
    (state) => state.setCurrentLanguage
  );

  // Only fetch cart data if cartToken is provided (checkout pages)
  const { data: cartData } = useQuery({
    queryKey: ["cart", cartToken],
    queryFn: () => fetchCart(cartToken!),
    enabled: !!cartToken,
  });

  // Only use cart language if no user language is persisted (checkout only)
  useEffect(() => {
    if (cartToken && cartData?.cart?.language_iso) {
      const persistedLanguage = useLocaleStore.getState().currentLanguage;
      if (persistedLanguage === "en") {
        setCurrentLanguage(cartData.cart.language_iso);
      }
    }
  }, [cartToken, cartData?.cart?.language_iso, setCurrentLanguage]);

  return <>{children}</>;
}
